import React from 'react'
import './Header.css'

const Header = ({handleSearchDrink}) => {
    return (
        <header>
            <div id="backgroundVideo">
                <video preload="auto" muted loop autoPlay src='https://assets.mixkit.co/videos/preview/mixkit-experimental-cocktail-in-the-bar-4416-large.mp4'>
                </video>
            </div>
            <div id="containHeader">
                <h1>Welcome Mr. Bartender</h1>
                <h3>Find the drink to prepare </h3>
                <form>
                    <input type='text' placeholder='Enter the name of the drink' 
                        autoFocus onChange={(e)=>{
                            handleSearchDrink(e.target.value)
                        }} ></input>
                    
                </form>
            </div>
        </header>
    )
}

export default Header